module.exports = __webpack_public_path__ + "images/bug_orange_size_4_7a30233ea212d5c874b7ba1241bb1f2f.png";